import { useState, useEffect } from 'react';

/**
 * Hook to calculate dynamic content height based on viewport
 * Adjusts automatically for landscape/portrait orientation
 * @param {number} headerOffset - Height of fixed headers/toolbars (default: 220px)
 * @returns {string} - CSS calc() value for maxHeight
 */
const useContentHeight = (headerOffset = 220) => {
  const [contentHeight, setContentHeight] = useState(`calc(100vh - ${headerOffset}px)`);

  useEffect(() => {
    const calculateHeight = () => {
      const vh = window.innerHeight;
      const isLandscape = window.innerWidth > window.innerHeight;
      const isMobile = vh < 500 || window.innerWidth < 768;
      
      // Adjust offset based on orientation and device
      let offset = headerOffset;
      
      if (isMobile && isLandscape) {
        // Landscape mobile: reduce offset for more content space
        offset = Math.min(headerOffset, 160);
      } else if (isMobile) {
        // Portrait mobile
        offset = headerOffset;
      }
      
      setContentHeight(`calc(100vh - ${offset}px)`);
    };

    calculateHeight();
    window.addEventListener('resize', calculateHeight);
    window.addEventListener('orientationchange', calculateHeight);

    return () => {
      window.removeEventListener('resize', calculateHeight);
      window.removeEventListener('orientationchange', calculateHeight);
    };
  }, [headerOffset]);

  return contentHeight;
};

export default useContentHeight;
